import apiClient from '../lib/apiClient';
import type { Review, ReviewSuggestionPatchRequest } from '@corner/shared';

/**
 * Create a new review for a file or document.
 */
export async function createReview(
  input: { sourceKind: 'file' | 'document'; sourceId: string; title?: string },
): Promise<Review> {
  const { data } = await apiClient.post<Review>('/api/reviews', input);
  return data;
}

/**
 * Get a review by ID.
 */
export async function getReview(
  reviewId: string,
): Promise<Review> {
  const { data } = await apiClient.get<Review>(`/api/reviews/${reviewId}`);
  return data;
}

/**
 * Trigger AI-powered review suggestion generation.
 * Returns the updated review with suggestions populated.
 */
export async function generateReview(
  reviewId: string,
): Promise<Review> {
  const { data } = await apiClient.post<Review>(`/api/reviews/${reviewId}/generate`, {});
  return data;
}

/**
 * Update a suggestion's status (accept / dismiss / revert to pending).
 */
export async function patchSuggestion(
  reviewId: string,
  suggestionId: string,
  patch: ReviewSuggestionPatchRequest,
): Promise<Review> {
  const { data } = await apiClient.patch<Review>(
    `/api/reviews/${reviewId}/suggestions/${suggestionId}`,
    patch,
  );
  return data;
}

/**
 * Export the review as a document.
 */
export async function exportReview(
  reviewId: string,
): Promise<Review> {
  const { data } = await apiClient.post<Review>(`/api/reviews/${reviewId}/export`, {});
  return data;
}
